import { render, staticRenderFns } from "./TwUpdateHistory.vue?vue&type=template&id=36284f68&scoped=true&"
import script from "./TwUpdateHistory.vue?vue&type=script&lang=js&"
export * from "./TwUpdateHistory.vue?vue&type=script&lang=js&"
import style0 from "./TwUpdateHistory.vue?vue&type=style&index=0&id=36284f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36284f68",
  null
  
)

export default component.exports